import { extendTheme, Theme } from "@chakra-ui/react"
import { evtColors } from "./colors"
import { components } from "./components"

import { evtZIndex } from "./tools"

const BeatTheme: Partial<Theme> | ((outerTheme: Theme) => Theme) = extendTheme({
  components,
  colors: evtColors,
  fonts: {
    heading: "Inter, sans-serif",
    body: "Inter, sans-serif"
  },
  zIndices: evtZIndex
})

export default BeatTheme
